import { render, staticRenderFns } from "./BackboneView.vue?vue&type=template&id=fcb262ba"
import script from "./BackboneView.vue?vue&type=script&lang=js"
export * from "./BackboneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports